import { render, staticRenderFns } from "./transAccount.vue?vue&type=template&id=c46e35bc&scoped=true&"
import script from "./transAccount.vue?vue&type=script&lang=js&"
export * from "./transAccount.vue?vue&type=script&lang=js&"
import style0 from "./transAccount.vue?vue&type=style&index=0&id=c46e35bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c46e35bc",
  null
  
)

component.options.__file = "transAccount.vue"
export default component.exports